import React from 'react';
import Layout from '../components/Layout'; 
// import MainMenu from '../components/MainMenu.jsx';

function ShippingAndReturns() {

  window.scrollTo(0,0);

  return (
    <Layout>
      {/* <MainMenu /> */}
      <div className="container mx-auto py-0 px-4 w-4/5 ">
        {/* Shipping Section */}
        <h2 className="text-2xl font-semibold mb-4 text-center mt-8">Shipping</h2>
        <p className="text-center mb-4">
          All items (unless specified) will be shipped within 5 working days of your order, please keep in mind when looking at timings below.
        </p>
        <p className="text-center mb-4">
          Please let us know if you have a deadline to keep and we will do our best to get it to you in time.
        </p>

        <p className="text-center mb-4">
          <strong>Delivery Options ~</strong>
        </p>
        <ul className="text-center mb-4 space-y-2">
          <li>Royal Mail Tracked 24 (delivery next working day)</li>
          <li>Royal Mail Europe Tracked and Signed (delivery in 3-5 working days)</li>
          <li>Royal Mail International Tracked and Signed (delivery in 5-7 working days)</li>
        </ul>

        {/* Returns & Exchanges Section */}
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-center">Returns & Exchanges</h2>
        <p className="text-center mb-4">
          We hope you love your pieces, but if something isn't quite right, we understand and will accept returns & exchanges, as long as the pieces are unworn and postage is covered for the return / exchange. Please note that any customs fees that may occur will also be covered by the customer.
        </p>
        <p className="text-center mb-4">
          If you need to return an item, contact us and we can process that for you, as long as the pieces are unworn, you will have up to 14 days to send proof of the returns postage (14 days from receiving your item). There will be a £5 processing fee deducted from your refund. Any returns / exchange postage will be paid for by the customer.
        </p>
        <p className="text-center mb-4">
          Please note that all sale items are final and not eligible for returns or exchanges.
        </p>
      </div>
    </Layout>
  );
}

export default ShippingAndReturns;
